import React from 'react';
import './TokenHero.css';
import {joinClassNames} from '../../gameUi/joinClassNames';

/**
 * Крупный жетон карточки: панель осмотра ячейки и описание строения. При смене жетона
 * ложится на место со вспышкой, от него расходится волна. Цвет рамки и свечения —
 * --gui-pc от родителя
 *
 * @param {string} animationKey - смена перезапускает вспышку и волну
 * @param {boolean} [isFramed] - рамка и свечение: у ячейки без владельца их нет
 * @param {React.ReactNode} children - сам жетон
 */
const TokenHero = ({animationKey, isFramed, children}) => (
  <div className={joinClassNames('token-hero', isFramed && 'token-hero_framed')}>
    <span className={'token-hero_glow'} aria-hidden={true}/>
    <span key={`ring-${animationKey}`} className={'token-hero_ring'} aria-hidden={true}/>
    <div key={animationKey} className={'token-hero_token'}>{children}</div>
  </div>
);

export default TokenHero;
